import { MarketerProductsColumnKeys } from '../declarations/marketerProducts/marketerProducts';
import { MarketersListColumnKeys } from '../declarations/marketersList/marketersList';
import { Marketer, MarketerProduct } from '../typings/marketers';

export const routeMarketersToKeyMap = {
    [MarketersListColumnKeys.ID]: (item: Marketer): string => item.id,
    [MarketersListColumnKeys.LOGIN]: (item: Marketer): string => item.login,
    [MarketersListColumnKeys.FULL_NAME]: (item: Marketer): string => item.fullName.toLowerCase()
};

export const routeMarketerProductsToKeyMap = {
    [MarketerProductsColumnKeys.ID]: (item: MarketerProduct): string => item.id,
    [MarketerProductsColumnKeys.PRODUCT_NAME]: (item: MarketerProduct): string => item.productName.toLowerCase()
};
